import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const LocationsSkeleton = (): JSX.Element => {
    return (
        <>
            <div className="is-flex is-flex-direction-row is-justify-content-space-between is-align-items-center mt-6">
                <h1 className="is-size-5 has-text-ldark-gray">Locations</h1>
                <Skeleton />
            </div>
            <div className="divider" />
            <div>
                <div className="is-flex is-flex-direction-row is-align-items-center">
                    <div className="has-text-weight-normal">
                        <Skeleton />
                    </div>
                    <div className="column is-one-fifth ml-6">
                        <Skeleton />
                    </div>
                </div>
                <div className="box">
                    <div className="columns is-align-items-center">
                        <div className="column is-one-quarter">
                            <div className="has-text-weight-semibold mb-2">
                                <Skeleton />
                            </div>
                            <div className="is-size-7">
                                <Skeleton />
                            </div>
                            <div className="is-size-7">
                                <Skeleton />
                            </div>
                        </div>
                        <div className="column is-one-quarter">
                            <div className="is-size-7">
                                <Skeleton />
                            </div>
                            <div className="has-text-weight-bold is-size-7">
                                <Skeleton />
                            </div>
                        </div>
                        <div className="column" />
                        <div className="column is-one-fifth">
                            <div className="is-flex is-flex-direction-column">
                                <Skeleton />
                                <Skeleton />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
